/**
 * 解析URL查询字符串参数
 * @param {string} queryString - 查询参数字符串
 * @returns {object} 包含所有参数的对象
 */
export const parseQueryString = (queryString: string) => {
  // 去掉开头的问号（如果有）
  const cleanQuery = queryString.startsWith('?')
    ? queryString.substring(1)
    : queryString

  // 使用URLSearchParams API解析
  const searchParams = new URLSearchParams(cleanQuery)

  // 转换为普通对象
  return Object.fromEntries(searchParams.entries())
}
